enum SendMessageAllowedHourEnum {
	StartHour = 7,
	EndHour = 19,
}

export {SendMessageAllowedHourEnum};
